import React, { useState } from 'react';
import apiFetch, { clearAuthExpiredLatch } from '../utils/apiFetch';

/**
 * 极简自带样式的登录页面（不依赖外部CSS/AntD）
 * 适配PC和移动端，表单校验和交互完整
 */
export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // 登录表单提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim()) {
      setError('请输入用户名');
      return;
    }
    if (!password) {
      setError('请输入密码');
      return;
    }
    setLoading(true);
    try {
      const res = await apiFetch('/api/user/login', {
        method: 'POST',
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (data.success) {
        clearAuthExpiredLatch();
        localStorage.setItem('token', data.token);
        // 兼容后端返回字符串或数组
        let perms = data.permissions;
        if (typeof perms === 'string') {
          perms = perms.split(',').map(s => s.trim());
        }
        localStorage.setItem('permissions', JSON.stringify(perms || []));
        localStorage.setItem('username', username);
        if (data.role) localStorage.setItem('role', data.role);

        // 权限配置：优先用登录接口返回；失败再走公开接口（不再依赖管理员接口）
        if (Array.isArray(data.permissionConfig)) {
          localStorage.setItem('permissionConfig', JSON.stringify(data.permissionConfig));
        } else {
          try {
            const permConfigRes = await apiFetch('/api/user/permission-config');
            const permConfigData = await permConfigRes.json();
            if (permConfigData.success) {
              localStorage.setItem('permissionConfig', JSON.stringify(permConfigData.permissions || []));
            } else {
              localStorage.removeItem('permissionConfig');
            }
          } catch (error) {
            console.error('获取权限配置失败:', error);
            localStorage.removeItem('permissionConfig');
          }
        }

        window.location.href = '/dashboard';
      } else {
        setError(data.error || '登录失败');
      }
    } catch {
      setError('网络错误');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f7fafd', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form
        onSubmit={handleSubmit}
        style={{
          width: 320,
          maxWidth: '90vw',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 16px #0001',
          padding: 32,
          display: 'flex',
          flexDirection: 'column',
          gap: 18
        }}
        autoComplete="off"
      >
        <h2 style={{ textAlign: 'center', color: '#1976d2', marginBottom: 8 }}>用户登录</h2>
        <label style={{ fontWeight: 500, marginBottom: 2 }}>用户名</label>
        <input
          type="text"
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="请输入用户名"
          style={{
            height: 38,
            border: '1px solid #bbb',
            borderRadius: 6,
            padding: '0 12px',
            fontSize: 16
          }}
        />
        <label style={{ fontWeight: 500, marginBottom: 2 }}>密码</label>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="请输入密码"
          style={{
            height: 38,
            border: '1px solid #bbb',
            borderRadius: 6,
            padding: '0 12px',
            fontSize: 16
          }}
        />
        {error && <div style={{ color: 'red', textAlign: 'center', marginTop: 2 }}>{error}</div>}
        <button
          type="submit"
          disabled={loading}
          style={{
            height: 40,
            background: loading ? '#90caf9' : '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            fontSize: 18,
            fontWeight: 600,
            marginTop: 8,
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background 0.2s'
          }}
        >
          {loading ? '登录中...' : '登 录'}
        </button>
      </form>
    </div>
  );
} 